import { render, staticRenderFns } from "./GlobalAudioMixer.vue?vue&type=template&id=167fca0b&"
import script from "./GlobalAudioMixer.vue?vue&type=script&lang=ts&"
export * from "./GlobalAudioMixer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports